// import EntypoIcon from 'react-native-vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUICreateSalePageView from 'xui/modules/storeWebsite/BaseUICreateSalePageView'

export default class CreateSalePageView extends BaseUICreateSalePageView {}
